import * as def from './defaults';

import * as controls from './controls';
import * as hydraulics from './hydraulics';
import * as solarkit from './solar-kit';
import * as chimney from './chimney';

import { getComponentType } from '../project-definition-data-access';

const MAP = {
  controls,
  hydraulics,
  solarkit,
  chimney,
};
for (let i = 1; i < 10; i += 1) {
  MAP[`control-${i}`] = controls;
  MAP[`controls-${i}`] = controls;
  MAP[`hydraulics-${i}`] = hydraulics;
}
MAP.controllers = controls;
MAP.controller = controls;
MAP.controls = controls;
MAP.control = controls;
MAP['solar-kit'] = solarkit;
MAP.exhaust = chimney;

const settings = {
  // Force disable adding products
  components: {
    controller: { canAdd: true, canRemove: true, canReplace: true, selectable: true },
    hydraulics: { canAdd: true, canRemove: true, canReplace: true },
    solarkit: { canAdd: true, canRemove: true, canReplace: true },
    kettle: { canAdd: true, canRemove: true, canReplace: true },
    boiler: { canAdd: true, canRemove: true, canReplace: true },
    solar_boiler: { canAdd: true, canRemove: true, canReplace: true },
    pump: { canAdd: true, canRemove: true, canReplace: true },
    exhaust: { canAdd: true, canRemove: true, canReplace: false, selectable: true },
  },
};

export const AccessoryCategory = {
  ACCESSORIES: 0,
  ACCESSORY_COLLECTIONS: 1,
};


export function getIdOfAccessorySet(accessorySet) {
  return def.getIdOfAccessorySet(accessorySet);
}

export function getAccessoriesOfProductData(productData, category) {
  return def.getAccessoriesOfProductData(productData, category);
}

export function getComponentSetting(componentType, setting, defaultValue = null) {
  const componentTypeObject = getComponentType(componentType);
  if (!componentTypeObject) {
    return defaultValue;
  }
  const componentTypeName = componentTypeObject.type;
  if (!componentTypeName) {
    return defaultValue;
  }
  const componentSettings = settings.components[componentTypeName];
  if (!componentSettings) {
    return defaultValue;
  }
  const value = componentSettings[setting];
  if (value === null || typeof value === 'undefined') {
    return defaultValue;
  }
  return value;
}

export function instantiate(product, type, systemDefinition, systemProducts, basedOnObject) {
  if (!product) {
    return null;
  }
  if (type) {
    const util = MAP[type];
    if (util && util.instantiate) {
      return util.instantiate(product, type, systemDefinition, systemProducts, basedOnObject);
    }
  }
  return def.instantiate(product, type, systemDefinition, systemProducts, basedOnObject);
}

// Assign data of the previous object on a new object when replacing a slot
export function assignPropertiesFromObject(slotName, systemDefinition, systemProducts, otherObject) {
  if (slotName) {
    const util = MAP[slotName];
    if (util && util.assignPropertiesFromObject) {
      return util.assignPropertiesFromObject(slotName, systemDefinition, systemProducts, otherObject);
    }
  }
  return def.assignPropertiesFromObject(slotName, systemDefinition, systemProducts, otherObject);
}

export function getProductInfoBySlotName(slotName, systemDefinition, systemProducts) {
  if (slotName) {
    const util = MAP[slotName];
    if (util && util.getProductInfoBySlotName) {
      return util.getProductInfoBySlotName(slotName, systemDefinition, systemProducts);
    }
  }
  return def.getProductInfoBySlotName(slotName, systemDefinition, systemProducts);
}

export function getSystemObjectPropertyValue(slotName, systemDefinition, systemProducts) {
  if (slotName) {
    const util = MAP[slotName];
    if (util && util.getSystemObjectPropertyValue) {
      return util.getSystemObjectPropertyValue(slotName, systemDefinition, systemProducts);
    }
  }
  return def.getSystemObjectPropertyValue(slotName, systemDefinition, systemProducts);
}

export function setSystemObjectPropertyValue(slotName, value, systemDefinition, systemProducts) {
  if (slotName) {
    const util = MAP[slotName];
    if (util && util.setSystemObjectPropertyValue) {
      return util.setSystemObjectPropertyValue(slotName, value, systemDefinition, systemProducts);
    }
  }
  return def.setSystemObjectPropertyValue(slotName, value, systemDefinition, systemProducts);
}

export function canAddAnyProductToSystemDefinition(type, systemDefinition, systemProducts) {
  // eslint-disable-line
  if (getComponentSetting(type, 'canAdd') === false) {
    return false;
  }
  const util = MAP[type];
  if (util && util.canAddAnyProductToSystemDefinition) {
    const res = util.canAddAnyProductToSystemDefinition(type, systemDefinition, systemProducts);
    if (typeof res === 'boolean') {
      return res;
    }
  }
  return def.canAddAnyProductToSystemDefinition(type, systemDefinition, systemProducts);
}

export function canAddProductToSystemDefinition(type, systemDefinition, systemProducts, product) {
  // eslint-disable-line
  const util = MAP[type];
  if (util && util.canAddProductToSystemDefinition) {
    const res = util.canAddProductToSystemDefinition(type, systemDefinition, systemProducts, product);
    if (typeof res === 'boolean') {
      return res;
    }
  }
  return def.canAddProductToSystemDefinition(type, systemDefinition, systemProducts, product);
}

export function canReplaceProductInSystemDefinition(slotName, systemDefinition, systemProducts, product) {
  // eslint-disable-line
  if (getComponentSetting(slotName, 'canReplace') === false) {
    return false;
  }
  const util = MAP[slotName];
  if (util && util.canReplaceProductInSystemDefinition) {
    return util.canReplaceProductInSystemDefinition(slotName, systemDefinition, systemProducts, product);
  }
  return def.canReplaceProductInSystemDefinition(slotName, systemDefinition, systemProducts, product);
}

export function canRemoveProductFromSystemDefinition(slotName, systemDefinition, systemProducts, productInfo) {
  // eslint-disable-line
  if (getComponentSetting(slotName, 'canRemove') === false) {
    return false;
  }

  const util = MAP[slotName];
  if (util && util.canRemoveProductFromSystemDefinition) {
    return util.canRemoveProductFromSystemDefinition(slotName, systemDefinition, systemProducts, productInfo);
  }
  return def.canRemoveProductFromSystemDefinition(slotName, systemDefinition, systemProducts, productInfo);
}

export function addProductToSystemDefinition(type, product, systemDefinition, systemProducts) {
  // eslint-disable-line
  const util = MAP[type];
  if (util && util.addProductToSystemDefinition) {
    return util.addProductToSystemDefinition(type, product, systemDefinition, systemProducts);
  }
  return def.addProductToSystemDefinition(type, product, systemDefinition, systemProducts);
}

export function replaceProductInSystemDefinition(slotName, systemDefinition, systemProducts, product) {
  // eslint-disable-line
  if (getComponentSetting(slotName, 'canReplace') === false) {
    return false;
  }
  const util = MAP[slotName];
  if (util && util.replaceProductInSystemDefinition) {
    return util.replaceProductInSystemDefinition(slotName, systemDefinition, systemProducts, product);
  }
  return def.replaceProductInSystemDefinition(slotName, systemDefinition, systemProducts, product);
}

export function removeProductFromSystemDefinition(slotName, systemDefinition, systemProducts) {
  // eslint-disable-line
  if (getComponentSetting(slotName, 'canRemove') === false) {
    return false;
  }

  const util = MAP[slotName];
  if (util && util.removeProductFromSystemDefinition) {
    return util.removeProductFromSystemDefinition(slotName, systemDefinition, systemProducts);
  }
  return def.removeProductFromSystemDefinition(slotName, systemDefinition, systemProducts);
}

function assignAvailableNewProductsForSystemDefinition(type, systemDefinition, systemProducts, result) {
  if (!type || !result) {
    return;
  }
  const util = MAP[type];

  const res = result;
  const categories = res.categories || [];
  const categoriesByName = res.categoriesByName || {};

  res.categories = categories;
  res.categoriesByName = categoriesByName;

  if (!canAddAnyProductToSystemDefinition(type, systemDefinition, systemProducts)) {
    return;
  }

  const method = util ? util.getAvailableNewProductsForSystemDefinition : null;
  let resultArray = null;
  if (method) {
    const array = util.getAvailableNewProductsForSystemDefinition(systemDefinition, systemProducts);
    if (array) {
      resultArray = array;
    }
  }
  if (!resultArray && def.getAvailableNewProductsForSystemDefinition) {
    const array = def.getAvailableNewProductsForSystemDefinition(type, systemDefinition, systemProducts);
    if (array) {
      resultArray = array;
    }
  }
  if (resultArray && resultArray.length > 0) {
    let category = categoriesByName[type];
    if (category) {
      category.products = resultArray;
    } else {
      const products = resultArray;
      category = { type, products };
      categoriesByName[type] = category;
      categories.push(category);
    }
  }
}

export function getAvailableNewProductsForSystemDefinition(systemDefinition, systemProducts) {
  // eslint-disable-line
  if (!systemDefinition || !systemProducts) {
    return null;
  }
  const result = {};

  assignAvailableNewProductsForSystemDefinition('controls', systemDefinition, systemProducts, result);
  assignAvailableNewProductsForSystemDefinition('hydraulics', systemDefinition, systemProducts, result);
  assignAvailableNewProductsForSystemDefinition('solarkit', systemDefinition, systemProducts, result);
  assignAvailableNewProductsForSystemDefinition('kettle', systemDefinition, systemProducts, result);
  assignAvailableNewProductsForSystemDefinition('boiler', systemDefinition, systemProducts, result);
  assignAvailableNewProductsForSystemDefinition('solar_boiler', systemDefinition, systemProducts, result);
  assignAvailableNewProductsForSystemDefinition('pump', systemDefinition, systemProducts, result);
  assignAvailableNewProductsForSystemDefinition('exhaust', systemDefinition, systemProducts, result);

  return result;
}

export function getAvailableReplacementProductsForSystemDefinition(slotName, systemDefinition, systemProducts) {
  // eslint-disable-line
  const util = MAP[slotName];
  if (util && util.getAvailableReplacementProductsForSystemDefinition) {
    return util.getAvailableReplacementProductsForSystemDefinition(slotName, systemDefinition, systemProducts);
  }
  return def.getAvailableReplacementProductsForSystemDefinition(slotName, systemDefinition, systemProducts);
}

export function getProductData(slotName, systemDefinition, systemProducts) {
  return def.getProductData(slotName, systemDefinition, systemProducts);
}

export function resetObjectAtSystemDefinitionSlot(slotName, systemDefinition, systemProducts) {
  const util = MAP[slotName];
  if (util && util.resetObjectAtSystemDefinitionSlot) {
    return util.resetObjectAtSystemDefinitionSlot(slotName, systemDefinition, systemProducts);
  }
  return def.resetObjectAtSystemDefinitionSlot(slotName, systemDefinition, systemProducts);
}

// ////////////////////////////////////////////////////////////////
//
// Accessories
//
// ////////////////////////////////////////////////////////////////
export function findAccessoryInfo(accessory, slotName, systemDefinition, systemProducts) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.findAccessoryInfo) {
    return util.findAccessoryInfo(accessory, slotName, systemDefinition, systemProducts);
  }
  return def.findAccessoryInfo(accessory, slotName, systemDefinition, systemProducts);
}

export function accessoryInArray(id, array, slotName = null) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.accessoryInArray) {
    return util.accessoryInArray(id, array, slotName);
  }
  return def.accessoryInArray(id, array);
}

export function removeAccessories(slotName, systemDefinition, systemProducts) {
  // eslint-disable-line
  const util = MAP[slotName];
  if (util && util.removeAccessories) {
    return util.removeAccessories(slotName, systemDefinition, systemProducts);
  }
  return def.removeAccessories(slotName, systemDefinition, systemProducts);
}

export function instantiateAccessory(accessory, slotName, systemDefinition, systemProducts) {
  const util = MAP[slotName];
  if (util && util.removeAccessories) {
    return util.instantiateAccessory(accessory, slotName, systemDefinition, systemProducts);
  }
  return def.instantiateAccessory(accessory, slotName, systemDefinition, systemProducts);
}

export function addAccessoryInstanceToArray(slotName, accessoryInstance, array, systemDefinition, systemProducts) {
  const util = MAP[slotName];
  if (util && util.addAccessoryInstanceToArray) {
    return util.addAccessoryInstanceToArray(accessoryInstance, array, systemDefinition, systemProducts, slotName);
  }
  return def.addAccessoryInstanceToArray(accessoryInstance, array, systemDefinition, systemProducts, slotName);
}

export function addAccessoryToArray(slotName, accessory, array, systemDefinition, systemProducts) {
  const util = MAP[slotName];
  if (util && util.addAccessoryToArray) {
    return util.addAccessoryToArray(accessory, array, systemDefinition, systemProducts, slotName);
  }
  return def.addAccessoryToArray(accessory, array, systemDefinition, systemProducts, slotName);
}

export function addOptionalAccessoryToArray(slotName, accessory, optionalAccessorySet, array, systemDefinition, systemProducts) {
  const util = MAP[slotName];
  if (util && util.addOptionalAccessoryToArray) {
    return util.addOptionalAccessoryToArray(accessory, optionalAccessorySet, array, systemDefinition, systemProducts, slotName);
  }
  return def.addOptionalAccessoryToArray(accessory, optionalAccessorySet, array, systemDefinition, systemProducts, slotName);
}

export function addAccessory(slotName, accessory, systemDefinition, systemProducts) {
  const util = MAP[slotName];
  if (util && util.addAccessory) {
    return util.addAccessory(slotName, accessory, systemDefinition, systemProducts);
  }
  return def.addAccessory(slotName, accessory, systemDefinition, systemProducts);
}

export function removeAccessory(slotName, accessory, systemDefinition, systemProducts) {
  const util = MAP[slotName];
  if (util && util.removeAccessory) {
    return util.removeAccessory(slotName, accessory, systemDefinition, systemProducts);
  }
  return def.removeAccessory(slotName, accessory, systemDefinition, systemProducts);
}

export function getSystemObjectAccessories(slotName, systemDefinition, systemProducts, productParam, onlyOptionalAccessories) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.getSystemObjectAccessories) {
    return util.getSystemObjectAccessories(slotName, systemDefinition, systemProducts, productParam, onlyOptionalAccessories);
  }
  return def.getSystemObjectAccessories(slotName, systemDefinition, systemProducts, productParam, onlyOptionalAccessories);
}

export function getSystemObjectAccessoriesByData(slotName, data, systemDefinition, systemProducts, productParam, onlyOptionalAccessories) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.getSystemObjectAccessoriesByData) {
    return util.getSystemObjectAccessoriesByData(slotName, data, systemDefinition, systemProducts, productParam, onlyOptionalAccessories);
  }
  return def.getSystemObjectAccessoriesByData(slotName, data, systemDefinition, systemProducts, productParam, onlyOptionalAccessories);
}

export function getSystemObjectProperties(slotName, systemDefinition, systemProducts, productParam) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.getSystemObjectProperties) {
    return util.getSystemObjectProperties(slotName, systemDefinition, systemProducts, productParam);
  }
  return def.getSystemObjectProperties(slotName, systemDefinition, systemProducts, productParam);
}

export function getSystemObjectSelectedAccessories(slotName, systemDefinition, systemProducts) {
  // eslint-disable-line
  const util = slotName ? MAP[slotName] : null;
  if (util && util.getSystemObjectSelectedAccessories) {
    return util.getSystemObjectSelectedAccessories(slotName, systemDefinition, systemProducts);
  }
  return def.getSystemObjectSelectedAccessories(slotName, systemDefinition, systemProducts);
}

// option: optionId
// modelType:
export function findOptionIndex(option, slotName, systemDefinition, systemProducts) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.findOptionIndex) {
    return util.findOptionIndex(option, slotName, systemDefinition, systemProducts);
  }
  return def.findOptionIndex(option, slotName, systemDefinition, systemProducts);
}

export function canExcludeFromQuote(slotName, systemDefinition, systemProducts) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.canExcludeFromQuote) {
    return util.canExcludeFromQuote(slotName, systemDefinition, systemProducts);
  }
  return def.canExcludeFromQuote(slotName, systemDefinition, systemProducts);
}

// /////////////////////////////////////////////////////////////////////////////
//
// Other product properties
//
// /////////////////////////////////////////////////////////////////////////////
export function getProductName(
  slotName,
  systemDefinition,
  systemProducts,
  productData,
  intl, // eslint-disable-line
) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.getProductName) {
    return util.getProductName(slotName, systemDefinition, systemProducts, productData, intl);
  }
  return def.getProductName(slotName, systemDefinition, systemProducts, productData, intl);
}

export function getProductBrandName(
  slotName,
  systemDefinition,
  systemProducts,
  productData,
  intl, // eslint-disable-line
) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.getProductBrandName) {
    return util.getProductBrandName(slotName, systemDefinition, systemProducts, productData, intl);
  }
  return def.getProductBrandName(slotName, systemDefinition, systemProducts, productData, intl);
}

export function getProductDescription(slotName, systemDefinition, systemProducts, productData, intl) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.getProductDescription) {
    return util.getProductDescription(slotName, systemDefinition, systemProducts, productData, intl);
  }
  return def.getProductDescription(slotName, systemDefinition, systemProducts, productData, intl);
}

export function hasProductDescription(slotName, systemDefinition, systemProducts, productData) {
  const util = slotName ? MAP[slotName] : null;
  if (util && util.hasProductDescription) {
    return util.hasProductDescription(slotName, systemDefinition, systemProducts, productData);
  }
  return def.hasProductDescription(slotName, systemDefinition, systemProducts, productData);
}



// WEBPACK FOOTER //
// ./js/utils/project-definition/component/index.js